var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m19.389 11.123c-.331 0-.6.269-.6.6v6.222c0 1.63-1.326 2.956-2.956 2.956h-9.777c-1.63 0-2.956-1.326-2.956-2.956v-9.777c0-1.63 1.326-2.956 2.956-2.956h6.222c.332 0 .6-.269.6-.6s-.269-.6-.6-.6h-6.222c-2.292 0-4.156 1.864-4.156 4.155v9.777c0 2.291 1.864 4.155 4.156 4.155h9.777c2.291 0 4.155-1.864 4.155-4.155v-6.222c0-.331-.269-.6-.6-.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m21.5 1.9h-4.802c-.331 0-.6.269-.6.6s.269.6.6.6h3.354l-7.672 7.671c-.234.233-.234.614 0 .848.117.117.271.176.424.176s.307-.059.424-.176l7.671-7.671v3.384c0 .331.269.6.6.6s.6-.269.6-.6v-4.832c0-.331-.269-.6-.6-.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.d79ae49267b33b23a4ec9073f7258aa4.svg";
export { ForwardRef as ReactComponent };